import { StockOrderDetailsFormValues } from "./types";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "./constants";

export interface StockOrderDetailsFormProps {
  children?: React.ReactNode;
  defaultFormValues?: Partial<StockOrderDetailsFormValues>;
}

export const StockOrderDetailsFormProvider = ({
  children,
  defaultFormValues,
}: StockOrderDetailsFormProps) => {
  const methods = useForm<StockOrderDetailsFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
